// // import { useEffect, useState, useRef } from "react";
// // // import axios from "axios";
// // import { jwtDecode } from "jwt-decode";
// // // eslint-disable-next-line no-unused-vars
// // import { FiSend, FiPaperclip } from "react-icons/fi"; // ✅ Icons
// // import socket from "../../utils/socket";

// // const ChatBox = ({ groupId, chatTitle, onClose, visible }) => {
// //   const [messages, setMessages] = useState([]);
// //   const [input, setInput] = useState("");
// //   const [isTyping, setIsTyping] = useState(false);
// //   const [typingUser, setTypingUser] = useState("");
// //   const [mentionList, setMentionList] = useState([]);
// //   const [mentionDropdown, setMentionDropdown] = useState([]);
// //   const [showDropdown, setShowDropdown] = useState(false);
// //   const [attachment, setAttachment] = useState(null); // ✅ For file

// //   const messagesEndRef = useRef(null);
// //   const token = localStorage.getItem("token");
// //   const storedUser = jwtDecode(token);

// //   const currentUser = {
// //     userId: storedUser?.userId,
// //     type: storedUser?.roles,
// //     name: storedUser?.userName,
// //     buyerId: storedUser?.buyerId,
// //     receiverIds: storedUser?.associated,
// //   };

// //   const REACT_APP_API_BASE_URL =
// //     process.env.REACT_APP_API_BASE_URL || "http://localhost:9001";

// //   const scrollToBottom = () => {
// //     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
// //   };

// //   useEffect(() => {
// //     if (!socket.connected) socket.connect();
// //     socket.emit("joinRoom", { groupId });

// //     // const fetchMessages = async () => {
// //     //   try {
// //     //     const res = await axios.post(
// //     //       `${REACT_APP_API_BASE_URL}socket/api/getMessagesBygroupId`,
// //     //       { groupId },
// //     //       { headers: { Authorization: `Bearer ${token}` } }
// //     //     );
// //     //     const msgs = Array.isArray(res.data) ? res.data : res.data?.messages || [];
// //     //     setMessages(msgs);
// //     //     scrollToBottom();
// //     //   } catch (error) {
// //     //     console.error("Fetch error:", error.message);
// //     //   }
// //     // };

// //     const fetchMessages = async () => {
// //       try {
// //         const response = await fetch(
// //           `${REACT_APP_API_BASE_URL}socket/api/getMessagesBygroupId`,
// //           {
// //             method: "POST",
// //             headers: {
// //               "Content-Type": "application/json",
// //               Authorization: `Bearer ${token}`,
// //             },
// //             body: JSON.stringify({ groupId }),
// //           }
// //         );

// //         if (!response.ok) {
// //           throw new Error(`HTTP error! status: ${response.status}`);
// //         }

// //         const data = await response.json();
// //         const msgs = Array.isArray(data) ? data : data?.messages || [];
// //         setMessages(msgs);
// //         scrollToBottom();
// //       } catch (error) {
// //         console.error("Fetch error:", error.message);
// //       }
// //     };

// //     // const fetchMentionUser = async () => {
// //     //   try {
// //     //     const res = await axios.post(
// //     //       `${REACT_APP_API_BASE_URL}socket/api/fetchMentionUser`,
// //     //       { senderId: currentUser.userId },
// //     //       { headers: { Authorization: `Bearer ${token}` } }
// //     //     );
// //     //     setMentionList(res.data);
// //     //   } catch (error) {
// //     //     console.error("Mention user fetch error:", error.message);
// //     //   }
// //     // };

// //     const fetchMentionUser = async () => {
// //       try {
// //         const response = await fetch(
// //           `${REACT_APP_API_BASE_URL}socket/api/fetchMentionUser`,
// //           {
// //             method: "POST",
// //             headers: {
// //               "Content-Type": "application/json",
// //               Authorization: `Bearer ${token}`,
// //             },
// //             body: JSON.stringify({ senderId: currentUser.userId }),
// //           }
// //         );

// //         if (!response.ok) {
// //           throw new Error(`HTTP error! status: ${response.status}`);
// //         }

// //         const data = await response.json();
// //         setMentionList(data);
// //       } catch (error) {
// //         console.error("Mention user fetch error:", error.message);
// //       }
// //     };

// //     fetchMessages();
// //     fetchMentionUser();

// //     const handleNewMessage = (msg) => {
// //       if (msg.groupId === groupId) fetchMessages();
// //     };

// //     const handleTyping = ({ userName, chatId }) => {
// //       if (groupId === chatId && userName !== currentUser.name) {
// //         setTypingUser(userName);
// //         setIsTyping(true);
// //         setTimeout(() => setIsTyping(false), 3000);
// //       }
// //     };

// //     socket.on("newMessage", handleNewMessage);
// //     socket.on("typing", handleTyping);

// //     return () => {
// //       socket.emit("leaveRoom", groupId);
// //       socket.off("newMessage", handleNewMessage);
// //       socket.off("typing", handleTyping);
// //     };
// //   }, [
// //     REACT_APP_API_BASE_URL,
// //     currentUser.name,
// //     currentUser.userId,
// //     groupId,
// //     token,
// //   ]);

// //   const handleInputChange = (e) => {
// //     const value = e.target.value;
// //     setInput(value);
// //     socket.emit("typing", { userName: currentUser.name, groupId });

// //     const mentionMatch = value.match(/@(\w*)$/);
// //     if (mentionMatch) {
// //       const query = mentionMatch[1]?.toLowerCase();
// //       const filtered = mentionList.filter((u) =>
// //         u.name.toLowerCase().startsWith(query)
// //       );
// //       setMentionDropdown(filtered);
// //       setShowDropdown(true);
// //     } else {
// //       setShowDropdown(false);
// //     }
// //   };

// //   const handleMentionSelect = (name) => {
// //     const newText = input.replace(/@(\w*)$/, `@${name} `);
// //     setInput(newText);
// //     setShowDropdown(false);
// //   };

// //   const handleSend = () => {
// //     if (!input.trim() && !attachment) return;

// //     const newMsg = {
// //       groupId,
// //       chatId: groupId,
// //       senderId: currentUser.userId,
// //       senderType: currentUser.type,
// //       senderName: currentUser.name,
// //       receiverIds: currentUser.receiverIds,
// //       message: input,
// //       attachment: attachment ? attachment.name : null, // Stub, handle upload if needed
// //       timestamp: new Date().toISOString(),
// //     };

// //     socket.emit("sendMessage", newMsg);
// //     setMessages((prev) => [...prev, newMsg]);
// //     setInput("");
// //     setAttachment(null);
// //     scrollToBottom();
// //   };

// //   // eslint-disable-next-line no-unused-vars
// //   const handleAttachment = (e) => {
// //     const file = e.target.files[0];
// //     if (file) {
// //       setAttachment(file);
// //     }
// //   };

// //   const highlightIfMentioned = (msg) => msg.includes(`@${currentUser.name}`);

// //   const formatTime = (timestamp) => {
// //     const date = new Date(timestamp);
// //     let h = date.getHours();
// //     const m = date.getMinutes().toString().padStart(2, "0");
// //     const ampm = h >= 12 ? "PM" : "AM";
// //     h = h % 12 || 12;
// //     return `${h}:${m} ${ampm}`;
// //   };

// //   return (
// //     <div
// //       style={{
// //         ...styles.wrapper,
// //         transform: visible ? "translateX(0%)" : "translateX(100%)",
// //       }}
// //     >
// //       <div style={styles.header}>
// //         <span>
// //           💬 Chat: {chatTitle} #{groupId}
// //         </span>
// //         <button onClick={onClose} style={styles.closeBtn}>
// //           ×
// //         </button>
// //       </div>

// //       <div style={styles.body}>
// //         {messages.map((msg, i) => {
// //           const isSender = msg.senderId === currentUser.userId;
// //           const highlight = highlightIfMentioned(msg.message);
// //           return (
// //             <div
// //               key={i}
// //               style={{
// //                 ...styles.messageRow,
// //                 justifyContent: isSender ? "flex-end" : "flex-start",
// //               }}
// //             >
// //               <div
// //                 style={{
// //                   ...styles.messageBubble,
// //                   backgroundColor: highlight
// //                     ? "#fff8b3"
// //                     : isSender
// //                     ? "#d9fdd3"
// //                     : "#f0f0f0",
// //                 }}
// //               >
// //                 <div style={styles.sender}>
// //                   {isSender ? "You" : msg.senderName}
// //                 </div>
// //                 <div
// //                   dangerouslySetInnerHTML={{
// //                     __html: msg.message.replace(
// //                       /@(\w+)/g,
// //                       '<span style="color:#0b93f6;font-weight:bold;">@$1</span>'
// //                     ),
// //                   }}
// //                 />
// //                 {msg.attachment && (
// //                   <div style={{ marginTop: 6 }}>
                    
// //                     <span style={{ color: "#0077cc" }}>
// //                       {msg.attachment}
// //                     </span>
                    
// //                   </div>
// //                 )}
// //                 <div style={styles.timestamp}>{formatTime(msg.timestamp)}</div>
// //               </div>
// //             </div>
// //           );
// //         })}

// //         {isTyping && <div style={styles.typing}>{typingUser} is typing...</div>}
// //         <div ref={messagesEndRef} />
// //       </div>

// //       <div style={styles.inputArea}>
// //         <div style={styles.inputWrapper}>
// //           <input
// //             type="text"
// //             placeholder="Type your message..."
// //             value={input}
// //             onChange={handleInputChange}
// //             onKeyDown={(e) => e.key === "Enter" && handleSend()}
// //             style={styles.input}
// //           />
// //           {/* <label htmlFor="file-upload" style={styles.attachmentIcon}>
// //             <FiPaperclip size={18} />
// //             <input
// //               id="file-upload"
// //               type="file"
// //               style={{ display: "none" }}
// //               onChange={handleAttachment}
// //             />
// //           </label> */}
// //           <button onClick={handleSend} style={styles.sendBtn}>
// //             <FiSend size={18} />
// //           </button>
// //         </div>
// //         {showDropdown && (
// //           <div style={styles.dropdown}>
// //             {mentionDropdown.map((u) => (
// //               <div
// //                 key={u.userId}
// //                 onClick={() => handleMentionSelect(u.name)}
// //                 style={styles.dropdownItem}
// //               >
// //                 @{u.name}
// //               </div>
// //             ))}
// //           </div>
// //         )}
// //         {attachment && (
// //           <div style={styles.attachmentPreview}>📎 {attachment.name}</div>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // const styles = {
// //   wrapper: {
// //     position: "fixed",
// //     right: "400px",
// //     bottom: 20,
// //     width: 380,
// //     height: 600,
// //     backgroundColor: "#fff",
// //     border: "1px solid #ddd",
// //     borderRadius: "12px",
// //     boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
// //     display: "flex",
// //     flexDirection: "column",
// //     zIndex: 9999,
// //     transform: "translateX(100%)",
// //     transition: "transform 0.5s ease-in-out",
// //   },
// //   header: {
// //     background: "#ededed",
// //     padding: "10px 15px",
// //     display: "flex",
// //     justifyContent: "space-between",
// //     alignItems: "center",
// //     fontWeight: "bold",
// //     borderBottom: "1px solid #ccc",
// //   },
// //   closeBtn: {
// //     background: "transparent",
// //     border: "none",
// //     fontSize: "18px",
// //     cursor: "pointer",
// //   },
// //   body: {
// //     flex: 1,
// //     padding: "10px",
// //     overflowY: "auto",
// //   },
// //   messageRow: {
// //     display: "flex",
// //     marginBottom: 10,
// //   },
// //   messageBubble: {
// //     maxWidth: "75%",
// //     padding: "8px 12px",
// //     borderRadius: "10px",
// //     lineHeight: 1.4,
// //     fontSize: "14px",
// //     boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
// //   },
// //   sender: {
// //     fontWeight: "bold",
// //     marginBottom: 2,
// //   },
// //   timestamp: {
// //     fontSize: "10px",
// //     textAlign: "right",
// //     marginTop: 4,
// //     color: "#999",
// //   },
// //   typing: {
// //     fontStyle: "italic",
// //     fontSize: "12px",
// //     color: "#555",
// //     margin: "5px 0",
// //   },
// //   inputArea: {
// //     borderTop: "1px solid #eee",
// //     padding: "10px",
// //     position: "relative",
// //   },
// //   inputWrapper: {
// //     display: "flex",
// //     alignItems: "center",
// //   },
// //   input: {
// //     flex: 1,
// //     padding: "8px 12px",
// //     borderRadius: "20px",
// //     border: "1px solid #ccc",
// //     outline: "none",
// //     fontSize: "14px",
// //   },
// //   sendBtn: {
// //     background: "#007bff",
// //     color: "#fff",
// //     border: "none",
// //     borderRadius: "50%",
// //     padding: "8px",
// //     marginLeft: "6px",
// //     cursor: "pointer",
// //   },
// //   attachmentIcon: {
// //     marginLeft: "6px",
// //     cursor: "pointer",
// //     color: "#555",
// //   },
// //   dropdown: {
// //     position: "absolute",
// //     bottom: "45px",
// //     left: "10px",
// //     right: "10px",
// //     backgroundColor: "#fff",
// //     border: "1px solid #ccc",
// //     borderRadius: "6px",
// //     maxHeight: "120px",
// //     overflowY: "auto",
// //     zIndex: 2000,
// //   },
// //   dropdownItem: {
// //     padding: "8px 12px",
// //     cursor: "pointer",
// //     borderBottom: "1px solid #eee",
// //   },
// //   attachmentPreview: {
// //     marginTop: "6px",
// //     fontSize: "12px",
// //     color: "#333",
// //   },
// // };

// // export default ChatBox;

// import { useEffect, useState, useRef } from "react";
// import { jwtDecode } from "jwt-decode";
// import { FiSend } from "react-icons/fi";
// import socket from "../../utils/socket";

// const REACT_APP_API_BASE_URL =
//   process.env.REACT_APP_API_BASE_URL || "http://localhost:9001";

// const ChatBox = ({ groupId, chatRow, onClose }) => {
//   const [messages, setMessages]           = useState([]);
//   const [input, setInput]                 = useState("");
//   const [isTyping, setIsTyping]           = useState(false);
//   const [typingUser, setTypingUser]       = useState("");
//   const [mentionList, setMentionList]     = useState([]);
//   const [mentionDropdown, setMentionDropdown] = useState([]);
//   const [showDropdown, setShowDropdown]   = useState(false);

//   const messagesEndRef = useRef(null);
//   const token          = localStorage.getItem("token");
//   const storedUser     = jwtDecode(token);

//   // ─── Resolve current user from JWT ───────────────────────────────
//   const roleId = storedUser?.roles?.[0]?.roleId || storedUser?.roles?.[0] || "";
//   const isVendor = roleId === "VENDOR";
//   const isBuyer  = roleId === "BUYER";
//   // Admin = anything that's not VENDOR / BUYER

//   const currentUser = {
//     userId : storedUser?.userId,
//     name   : storedUser?.userName,
//     type   : roleId,
//     buyerId: storedUser?.buyerId,
//   };

//   // ─── Dynamic chat title based on role ────────────────────────────
//   const chatTitle = isVendor
//     ? `Buyer: ${chatRow?.buyerName || chatRow?.buyerId || "Buyer"}`
//     : isBuyer
//     ? `Vendor: ${chatRow?.vendorName || chatRow?.vendorCode || "Vendor"}`
//     : `Vendor: ${chatRow?.vendorName || chatRow?.vendorCode || "Vendor"}`;  // Admin

//   const scrollToBottom = () =>
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });

//   // ─── Fetch messages for this PO room ─────────────────────────────
//   const fetchMessages = async () => {
//     try {
//       const res = await fetch(
//         `${REACT_APP_API_BASE_URL}socket/api/getMessagesBygroupId`,
//         {
//           method : "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization : `Bearer ${token}`,
//           },
//           body: JSON.stringify({ groupId }),
//         }
//       );
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const data = await res.json();
//       const msgs = Array.isArray(data) ? data : data?.messages || [];
//       setMessages(msgs);
//       setTimeout(scrollToBottom, 100);
//     } catch (err) {
//       console.error("fetchMessages err:", err.message);
//     }
//   };

//   // ─── Fetch @mention candidates ───────────────────────────────────
//   const fetchMentionUser = async () => {
//     try {
//       const res = await fetch(
//         `${REACT_APP_API_BASE_URL}socket/api/fetchMentionUser`,
//         {
//           method : "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization : `Bearer ${token}`,
//           },
//           body: JSON.stringify({ senderId: currentUser.userId }),
//         }
//       );
//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const data = await res.json();
//       setMentionList(data);
//     } catch (err) {
//       console.error("fetchMentionUser err:", err.message);
//     }
//   };

//   // ─── Socket setup ─────────────────────────────────────────────────
//   useEffect(() => {
//     if (!groupId) return;

//     if (!socket.connected) socket.connect();
//     socket.emit("joinRoom", { groupId });

//     fetchMessages();
//     fetchMentionUser();

//     const handleNewMessage = (msg) => {
//       if (msg.groupId === groupId) fetchMessages();
//     };

//     const handleTyping = ({ userName, groupId: chatId }) => {
//       if (groupId === chatId && userName !== currentUser.name) {
//         setTypingUser(userName);
//         setIsTyping(true);
//         setTimeout(() => setIsTyping(false), 3000);
//       }
//     };

//     socket.on("newMessage", handleNewMessage);
//     socket.on("typing",     handleTyping);

//     return () => {
//       socket.emit("leaveRoom", groupId);
//       socket.off("newMessage", handleNewMessage);
//       socket.off("typing",     handleTyping);
//     };
//   }, [groupId]);

//   // ─── Input & @mention ─────────────────────────────────────────────
//   const handleInputChange = (e) => {
//     const value = e.target.value;
//     setInput(value);
//     socket.emit("typing", { userName: currentUser.name, groupId });

//     const match = value.match(/@(\w*)$/);
//     if (match) {
//       const q        = match[1]?.toLowerCase();
//       const filtered = mentionList.filter((u) =>
//         u.name.toLowerCase().startsWith(q)
//       );
//       setMentionDropdown(filtered);
//       setShowDropdown(true);
//     } else {
//       setShowDropdown(false);
//     }
//   };

//   const handleMentionSelect = (name) => {
//     setInput((prev) => prev.replace(/@(\w*)$/, `@${name} `));
//     setShowDropdown(false);
//   };

//   // ─── Send message ─────────────────────────────────────────────────
//   const handleSend = () => {
//     if (!input.trim()) return;

//     const newMsg = {
//       groupId,
//       chatId  : groupId,
//       senderId: currentUser.userId,
//       senderType: currentUser.type,
//       senderName: currentUser.name,
//       // ✅ metadata so backend knows who to route to
//       vendorCode: chatRow?.vendorCode,
//       buyerId   : chatRow?.buyerId || storedUser?.buyerId,
//       purchasingDocumentNr: chatRow?.purchasingDocumentNr,
//       message  : input,
//       timestamp: new Date().toISOString(),
//     };

//     socket.emit("sendMessage", newMsg);
//     setMessages((prev) => [...prev, newMsg]);
//     setInput("");
//     scrollToBottom();
//   };

//   const highlightIfMentioned = (msg) =>
//     msg?.includes(`@${currentUser.name}`);

//   const formatTime = (ts) => {
//     if (!ts) return "";
//     const d    = new Date(ts);
//     let h      = d.getHours();
//     const m    = d.getMinutes().toString().padStart(2, "0");
//     const ampm = h >= 12 ? "PM" : "AM";
//     h          = h % 12 || 12;
//     return `${h}:${m} ${ampm}`;
//   };

//   // ─── Render ───────────────────────────────────────────────────────
//   return (
//     <div style={styles.wrapper}>
//       {/* Header */}
//       <div style={styles.header}>
//         <div style={{ display: "flex", flexDirection: "column" }}>
//           <span style={{ fontWeight: 700, fontSize: "13px" }}>
//             💬 {chatTitle}
//           </span>
//           <span style={{ fontSize: "11px", opacity: 0.7 }}>
//             PO: {groupId}
//           </span>
//         </div>
//         <button onClick={onClose} style={styles.closeBtn}>×</button>
//       </div>

//       {/* Messages */}
//       <div style={styles.body}>
//         {messages.length === 0 && (
//           <div style={{ textAlign: "center", color: "#aaa", marginTop: "40px", fontSize: "13px" }}>
//             No messages yet. Start the conversation!
//           </div>
//         )}
//         {messages.map((msg, i) => {
//           const isSender  = msg.senderId === currentUser.userId;
//           const highlight = highlightIfMentioned(msg.message);
//           return (
//             <div
//               key={i}
//               style={{
//                 ...styles.messageRow,
//                 justifyContent: isSender ? "flex-end" : "flex-start",
//               }}
//             >
//               <div
//                 style={{
//                   ...styles.messageBubble,
//                   background: highlight
//                     ? "#fff8b3"
//                     : isSender
//                     ? "#0d6efd"
//                     : "#fff",
//                   color: isSender && !highlight ? "#fff" : "#1a1a2e",
//                   borderRadius: isSender
//                     ? "14px 14px 2px 14px"
//                     : "14px 14px 14px 2px",
//                 }}
//               >
//                 <div style={styles.sender}>
//                   {isSender ? "You" : msg.senderName}
//                 </div>
//                 <div
//                   dangerouslySetInnerHTML={{
//                     __html: (msg.message || "").replace(
//                       /@(\w+)/g,
//                       '<span style="color:#ffd700;font-weight:bold;">@$1</span>'
//                     ),
//                   }}
//                 />
//                 <div style={styles.timestamp}>{formatTime(msg.timestamp)}</div>
//               </div>
//             </div>
//           );
//         })}

//         {isTyping && (
//           <div style={styles.typing}>{typingUser} is typing...</div>
//         )}
//         <div ref={messagesEndRef} />
//       </div>

//       {/* Input */}
//       <div style={styles.inputArea}>
//         {/* @mention dropdown */}
//         {showDropdown && mentionDropdown.length > 0 && (
//           <div style={styles.dropdown}>
//             {mentionDropdown.map((u) => (
//               <div
//                 key={u.userId}
//                 onClick={() => handleMentionSelect(u.name)}
//                 style={styles.dropdownItem}
//               >
//                 @{u.name}
//               </div>
//             ))}
//           </div>
//         )}

//         <div style={styles.inputWrapper}>
//           <input
//             type="text"
//             placeholder="Type a message..."
//             value={input}
//             onChange={handleInputChange}
//             onKeyDown={(e) => e.key === "Enter" && handleSend()}
//             style={styles.input}
//           />
//           <button onClick={handleSend} style={styles.sendBtn}>
//             <FiSend size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Styles ──────────────────────────────────────────────────────────────────
// const styles = {
//   wrapper: {
//     position       : "fixed",
//     right          : "24px",
//     bottom         : "20px",
//     width          : "380px",
//     height         : "560px",
//     backgroundColor: "#fff",
//     border         : "1px solid #ddd",
//     borderRadius   : "14px",
//     boxShadow      : "0 8px 30px rgba(0,0,0,0.18)",
//     display        : "flex",
//     flexDirection  : "column",
//     zIndex         : 99998,
//     animation      : "chatSlideIn 0.3s ease",
//   },
//   header: {
//     background    : "linear-gradient(135deg, #0d6efd, #0a58ca)",
//     padding       : "12px 16px",
//     borderRadius  : "14px 14px 0 0",
//     display       : "flex",
//     justifyContent: "space-between",
//     alignItems    : "center",
//     color         : "#fff",
//   },
//   closeBtn: {
//     background  : "rgba(255,255,255,0.2)",
//     border      : "none",
//     color       : "#fff",
//     borderRadius: "50%",
//     width       : "28px",
//     height      : "28px",
//     cursor      : "pointer",
//     fontSize    : "16px",
//     lineHeight  : 1,
//   },
//   body: {
//     flex      : 1,
//     padding   : "12px",
//     overflowY : "auto",
//     background: "#f8f9fa",
//     display   : "flex",
//     flexDirection: "column",
//     gap       : "6px",
//   },
//   messageRow: {
//     display: "flex",
//   },
//   messageBubble: {
//     maxWidth  : "75%",
//     padding   : "8px 12px",
//     boxShadow : "0 1px 4px rgba(0,0,0,0.08)",
//     fontSize  : "13px",
//     lineHeight: 1.5,
//   },
//   sender: {
//     fontWeight  : 600,
//     fontSize    : "11px",
//     marginBottom: "2px",
//     opacity     : 0.75,
//   },
//   timestamp: {
//     fontSize  : "10px",
//     textAlign : "right",
//     marginTop : "3px",
//     opacity   : 0.65,
//   },
//   typing: {
//     fontStyle: "italic",
//     fontSize : "12px",
//     color    : "#888",
//     margin   : "4px 0",
//   },
//   inputArea: {
//     borderTop : "1px solid #eee",
//     padding   : "10px",
//     background: "#fff",
//     borderRadius: "0 0 14px 14px",
//     position  : "relative",
//   },
//   inputWrapper: {
//     display    : "flex",
//     alignItems : "center",
//     gap        : "8px",
//   },
//   input: {
//     flex        : 1,
//     padding     : "9px 14px",
//     borderRadius: "20px",
//     border      : "1px solid #ddd",
//     outline     : "none",
//     fontSize    : "13px",
//     background  : "#f8f9fa",
//   },
//   sendBtn: {
//     background  : "#0d6efd",
//     color       : "#fff",
//     border      : "none",
//     borderRadius: "50%",
//     width       : "36px",
//     height      : "36px",
//     cursor      : "pointer",
//     display     : "flex",
//     alignItems  : "center",
//     justifyContent: "center",
//     flexShrink  : 0,
//   },
//   dropdown: {
//     position  : "absolute",
//     bottom    : "56px",
//     left      : "10px",
//     right     : "10px",
//     background: "#fff",
//     border    : "1px solid #ddd",
//     borderRadius: "8px",
//     maxHeight : "120px",
//     overflowY : "auto",
//     zIndex    : 10,
//     boxShadow : "0 2px 8px rgba(0,0,0,0.1)",
//   },
//   dropdownItem: {
//     padding     : "8px 12px",
//     cursor      : "pointer",
//     borderBottom: "1px solid #f0f0f0",
//     fontSize    : "13px",
//   },
// };

// export default ChatBox;

import { useEffect, useState, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import { FiSend } from "react-icons/fi";
import socket from "../../utils/socket";

const REACT_APP_API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:9001";

const MessageTicks = ({ isRead = false }) => {
  const tickColor = isRead ? "#1DA1F2" : "#94A3B8";

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        marginLeft: "auto",
      }}
    >
      <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
        <path
          d="M1.5 6.5L4.5 9.5L10.5 2"
          stroke={tickColor}
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 6.5L8.5 9.5L14.5 2"
          stroke={tickColor}
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

const ChatBox = ({ groupId, chatRow, onClose }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [typingUser, setTypingUser] = useState("");
  const [mentionList, setMentionList] = useState([]);
  const [mentionDropdown, setMentionDropdown] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const messagesEndRef = useRef(null);
  const token = localStorage.getItem("token");
  const storedUser = jwtDecode(token);

  const roleId = storedUser?.roles?.[0]?.roleId || storedUser?.roles?.[0] || "";
  const isVendor = roleId === "VENDOR";
  const isBuyer = roleId === "BUYER";

  const currentUser = {
    userId: storedUser?.userId,
    name: storedUser?.userName,
    type: roleId,
    buyerId: storedUser?.buyerId,
  };

  const chatTitle = isVendor
    ? `Buyer: ${chatRow?.buyerName || chatRow?.buyerId || "Buyer"}`
    : isBuyer
    ? `Vendor: ${chatRow?.vendorName || chatRow?.vendorCode || "Vendor"}`
    : `Vendor: ${chatRow?.vendorName || chatRow?.vendorCode || "Vendor"}`;

  const scrollToBottom = () =>
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });

  const fetchMessages = async () => {
    try {
      const res = await fetch(
        `${REACT_APP_API_BASE_URL}socket/api/getMessagesBygroupId`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ groupId }),
        }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const msgs = Array.isArray(data) ? data : data?.messages || [];
      setMessages(msgs);
      setTimeout(scrollToBottom, 100);
    } catch (err) {
      console.error("fetchMessages err:", err.message);
    }
  };

  const fetchMentionUser = async () => {
    try {
      const res = await fetch(
        `${REACT_APP_API_BASE_URL}socket/api/fetchMentionUser`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ senderId: currentUser.userId }),
        }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setMentionList(data);
    } catch (err) {
      console.error("fetchMentionUser err:", err.message);
    }
  };

  useEffect(() => {
    if (!groupId) return;

    if (!socket.connected) socket.connect();
    socket.emit("joinRoom", { groupId });

    fetchMessages();
    fetchMentionUser();

    const handleNewMessage = (msg) => {
      if (msg.groupId === groupId) fetchMessages();
    };

    const handleTyping = ({ userName, groupId: chatId }) => {
      if (groupId === chatId && userName !== currentUser.name) {
        setTypingUser(userName);
        setIsTyping(true);
        setTimeout(() => setIsTyping(false), 3000);
      }
    };

    const handleMessagesRead = ({ groupId: readGroupId }) => {
      if (readGroupId !== groupId) return;
      setMessages((prev) =>
        prev.map((msg) =>
          msg.senderId === currentUser.userId
            ? { ...msg, read: true }
            : msg
        )
      );
    };

    socket.on("newMessage", handleNewMessage);
    socket.on("typing", handleTyping);
    socket.on("messagesRead", handleMessagesRead);

    return () => {
      socket.emit("leaveRoom", groupId);
      socket.off("newMessage", handleNewMessage);
      socket.off("typing", handleTyping);
      socket.off("messagesRead", handleMessagesRead);
    };
    // eslint-disable-next-line
  }, [groupId]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInput(value);
    socket.emit("typing", { userName: currentUser.name, groupId });

    const match = value.match(/@(\w*)$/);
    if (match) {
      const q = match[1]?.toLowerCase();
      const filtered = mentionList.filter((u) =>
        u.name.toLowerCase().startsWith(q)
      );
      setMentionDropdown(filtered);
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handleMentionSelect = (name) => {
    setInput((prev) => prev.replace(/@(\w*)$/, `@${name} `));
    setShowDropdown(false);
  };

  const handleSend = () => {
    if (!input.trim()) return;

    const newMsg = {
      groupId,
      chatId: groupId,
      senderId: currentUser.userId,
      senderType: currentUser.type,
      senderName: currentUser.name,
      vendorCode: chatRow?.vendorCode,
      buyerId: chatRow?.buyerId || storedUser?.buyerId,
      purchasingDocumentNr: chatRow?.purchasingDocumentNr,
      message: input,
      timestamp: new Date().toISOString(),
      read: false,
    };

    socket.emit("sendMessage", newMsg);
    setMessages((prev) => [...prev, newMsg]);
    setInput("");
    setTimeout(scrollToBottom, 50);
  };

  const highlightIfMentioned = (msg) =>
    msg?.includes(`@${currentUser.name}`);

  const formatTime = (ts) => {
    if (!ts) return "";
    const d = new Date(ts);
    let h = d.getHours();
    const m = d.getMinutes().toString().padStart(2, "0");
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${m} ${ampm}`;
  };

  const isMessageRead = (msg) => {
    if (msg.read === true) return true;
    if (Array.isArray(msg.readBy) && msg.readBy.length > 0) return true;
    return false;
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.header}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={styles.headerTitle}>💬 {chatTitle}</span>
          <span style={styles.headerSubTitle}>PO: {groupId}</span>
        </div>
        <button onClick={onClose} style={styles.closeBtn}>×</button>
      </div>

      <div style={styles.body}>
        {messages.length === 0 && (
          <div style={styles.emptyState}>
            No messages yet. Start the conversation!
          </div>
        )}

        {messages.map((msg, i) => {
          const isSender = msg.senderId === currentUser.userId;
          const highlight = highlightIfMentioned(msg.message);

          return (
            <div
              key={i}
              style={{
                ...styles.messageRow,
                justifyContent: isSender ? "flex-end" : "flex-start",
              }}
            >
              <div
                style={{
                  ...styles.messageBubble,
                  background: highlight
                    ? "#FFF4CC"
                    : isSender
                    ? "#DCF8C6"
                    : "#F1F5F9",
                  color: "#1E293B",
                  borderRadius: isSender
                    ? "16px 16px 4px 16px"
                    : "16px 16px 16px 4px",
                  border: isSender
                    ? "1px solid #CFECC0"
                    : "1px solid #E2E8F0",
                }}
              >
                <div style={styles.sender}>
                  {isSender ? "You" : msg.senderName}
                </div>

                <div
                  dangerouslySetInnerHTML={{
                    __html: (msg.message || "").replace(
                      /@(\w+)/g,
                      '<span style="color:#1677ff;font-weight:700;">@$1</span>'
                    ),
                  }}
                />

                <div style={styles.footerRow}>
                  <span style={styles.timestamp}>{formatTime(msg.timestamp)}</span>
                  {isSender && <MessageTicks isRead={isMessageRead(msg)} />}
                </div>
              </div>
            </div>
          );
        })}

        {isTyping && (
          <div style={styles.typing}>{typingUser} is typing...</div>
        )}

        <div ref={messagesEndRef} />
      </div>

      <div style={styles.inputArea}>
        {showDropdown && mentionDropdown.length > 0 && (
          <div style={styles.dropdown}>
            {mentionDropdown.map((u) => (
              <div
                key={u.userId}
                onClick={() => handleMentionSelect(u.name)}
                style={styles.dropdownItem}
              >
                @{u.name}
              </div>
            ))}
          </div>
        )}

        <div style={styles.inputWrapper}>
          <input
            type="text"
            placeholder="Type a message..."
            value={input}
            onChange={handleInputChange}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
            style={styles.input}
          />
          <button onClick={handleSend} style={styles.sendBtn}>
            <FiSend size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    position: "fixed",
    right: "24px",
    bottom: "20px",
    width: "380px",
    height: "600px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E5E7EB",
    borderRadius: "16px",
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.14)",
    display: "flex",
    flexDirection: "column",
    zIndex: 9999,
    overflow: "hidden",
  },
  header: {
    background: "#F8FAFC",
    padding: "12px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #E5E7EB",
  },
  headerTitle: {
    fontWeight: 700,
    fontSize: "14px",
    color: "#1F2937",
  },
  headerSubTitle: {
    fontSize: "11px",
    color: "#6B7280",
    marginTop: "2px",
  },
  closeBtn: {
    background: "#EEF2F7",
    border: "1px solid #E2E8F0",
    color: "#475569",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    fontSize: "18px",
    cursor: "pointer",
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  body: {
    flex: 1,
    padding: "12px",
    overflowY: "auto",
    background: "#F8FAFC",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  emptyState: {
    textAlign: "center",
    color: "#94A3B8",
    marginTop: "40px",
    fontSize: "13px",
  },
  messageRow: {
    display: "flex",
  },
  messageBubble: {
    maxWidth: "76%",
    padding: "10px 12px",
    fontSize: "13px",
    lineHeight: 1.45,
    boxShadow: "0 1px 2px rgba(15, 23, 42, 0.05)",
  },
  sender: {
    fontWeight: 700,
    fontSize: "11px",
    marginBottom: "3px",
    color: "#334155",
  },
  footerRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginTop: "5px",
    gap: "6px",
  },
  timestamp: {
    fontSize: "10px",
    color: "#94A3B8",
  },
  typing: {
    fontStyle: "italic",
    fontSize: "12px",
    color: "#64748B",
    margin: "4px 0",
  },
  inputArea: {
    borderTop: "1px solid #E5E7EB",
    padding: "10px",
    position: "relative",
    background: "#FFFFFF",
  },
  inputWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  input: {
    flex: 1,
    padding: "10px 14px",
    borderRadius: "22px",
    border: "1px solid #D8E1EA",
    outline: "none",
    fontSize: "13px",
    background: "#F8FAFC",
    color: "#1F2937",
  },
  sendBtn: {
    background: "#3B82F6",
    color: "#FFFFFF",
    border: "none",
    borderRadius: "50%",
    width: "38px",
    height: "38px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    boxShadow: "0 4px 10px rgba(59, 130, 246, 0.24)",
  },
  dropdown: {
    position: "absolute",
    bottom: "58px",
    left: "10px",
    right: "10px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E2E8F0",
    borderRadius: "10px",
    maxHeight: "120px",
    overflowY: "auto",
    zIndex: 2000,
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.08)",
  },
  dropdownItem: {
    padding: "9px 12px",
    cursor: "pointer",
    borderBottom: "1px solid #F1F5F9",
    fontSize: "13px",
    color: "#334155",
    background: "#FFFFFF",
  },
};

export default ChatBox;